import * as formatter from "./formatter";

export default (Vue: any) => {
  Vue.directive("datetimetext", formatter.datetimetext);
};
